import React from 'react'
import Legacy from './Legacy'

const CustomMain = (props) => {
  return <Legacy {...props}/>
}

export default CustomMain
